import { orderBy } from 'lodash';
import React, { Fragment } from 'react';
import { colorFromInt } from '../../lib';
import { Urls } from '../../lib/enums/urls';
import { Ot7Game } from '../../models/Ot7Game';
import { Ot7Team } from '../../models/Ot7Team';
import useFetch from '../../overtime-lib/src/www/hooks/useFetch';
import TBD from '../TBD';
import './PlayoffsTable.scss';

const PlayoffsTable = () => {
	const fetchResult = useFetch<Ot7Team[]>({
		url: `${Urls.RestApiBaseUrl}/ot7_teams/v1/public`,
		key: 'ot7_teams',
	});

	const teams = fetchResult.result.read();

	const gamesResult = useFetch<Ot7Game[]>({
		url: `${Urls.RestApiBaseUrl}/ot7_games/v1/public?ot7_season_slug=season-4-playoffs&all=true`,
		key: 'ot7_games',
	});

	const gamesData = gamesResult.result.read();

	type teamStanding = Partial<Ot7Team> & {
		position: number;
		wins: number;
		losses: number;
	};

	// Calculate team records from games
	const calculateTeamRecords = () => {
		const records: Record<string, { wins: number; losses: number }> = {};

		// Initialize records for all teams
		teams.forEach((team) => {
			records[team.id] = { wins: 0, losses: 0 };
		});

		// Only count confirmed games
		const confirmedGames = gamesData.filter((game) => game.status === 'confirmed') || [];

		// Calculate wins and losses for each game
		confirmedGames.forEach((game) => {
			if (game.ot7_games_ot7_teams && game.ot7_games_ot7_teams.length === 2) {
				const team1 = game.ot7_games_ot7_teams[0];
				const team2 = game.ot7_games_ot7_teams[1];

				// Make sure both teams have scores
				if (team1.points != null && team2.points != null) {
					if (team1.points > team2.points) {
						// Team 1 wins
						if (records[team1.ot7_team_id]) {
							records[team1.ot7_team_id].wins++;
						}
						if (records[team2.ot7_team_id]) {
							records[team2.ot7_team_id].losses++;
						}
					} else if (team2.points > team1.points) {
						// Team 2 wins
						if (records[team2.ot7_team_id]) {
							records[team2.ot7_team_id].wins++;
						}
						if (records[team1.ot7_team_id]) {
							records[team1.ot7_team_id].losses++;
						}
					}
					// If scores are equal, it's a tie - we don't count it as win or loss
				}
			}
		});

		return records;
	};

	const teamRecords = calculateTeamRecords();

	console.log('Team Records:', teamRecords);

	// Hardcoded list of playoff teams
	const teamIdOrder = [
		'971d0571-20fb-4707-a070-e2bc44e630f6', // 24K
		'9be30b26-5936-48b9-b56e-d6456e25dab0', // C1N
		'f5b65194-efcc-43de-b6c6-935a9c3b91be', // California Power
		'589b5726-c4bc-4111-b5c2-91502a2c729a', // Cold Hearts
		'17719c9a-3445-439c-a0d7-5e66a4e5b7cc', // Level82
		'34e8eb25-abcc-4307-9b02-4f4188c6ee6c', // Lo-Pro
		'9068a093-d14e-4ca0-8540-867312db815f', // Midwest Boom
		'3afec11d-a93a-46ee-8af5-d763fb6f69eb', // Raw Miami
		'a9e45d01-a73d-4b90-8c73-f60324ecfe57', // RG3
		'b2f1134e-6d5e-425f-883e-76659eedda5c', // RWE
		'813986d0-bf96-4384-8b02-52cafe4910b7', // SFE
		'e73a9119-e136-40a5-9e73-1ac623264b3f', // Trillion Boys
		'14c0e06b-2fe4-4fc5-828b-adf529c08e03', // Tucson Turf
	];

	// Create standings only for playoff teams
	const playoffsStandings: teamStanding[] = teamIdOrder.map((teamId) => {
		const team = teams.find((t) => t.id === teamId);
		const record = teamRecords[teamId] || { wins: 0, losses: 0 };

		return {
			id: teamId,
			name: team?.name || '',
			position: null, // Position would need to be calculated separately if needed
			wins: record.wins,
			losses: record.losses,
		};
	});

	// Sort standings: by wins (desc), then by losses (asc), then alphabetically
	const sortedStandings = orderBy(playoffsStandings, ['wins', 'losses', 'name'], ['desc', 'asc', 'asc']);

	return (
		<>
			<div className="PlayoffsTable">
				<div className="TeamsContainer">
					{/* <div /> */}
					<div>Team</div>
					<div>W</div>
					<div>L</div>
					{/* <div className="Direction">
						<div className="Arrow">R</div>
					</div> */}
					{true ? (
						sortedStandings.map((t, i) => {
							const team = teams.find((team) => t.id == team.id);

							return (
								<Fragment key={t.id}>
									{/* <div className={`Position Row-${i + 1}`}>{(t.position ?? 0) || '-'}</div> */}
									<div className={`Name Row-${i + 1}`}>
										<a className="inherit" href={`/teams/${t.id}`}>
											<div className="TeamLogo" style={{ backgroundColor: colorFromInt(team?.primary_color) }}>
												<img src={`${Urls.OvertimeImagesBaseUrl}/${team?.logo_path}`} />
											</div>
											{t.name}
											{/* {isDivisionWinner && (
											<div className="Winner">
												{isGoldenTicketWinner && <img src={imgIconGoldenTicketSvg} alt="Golden Ticket" />}
												{!isGoldenTicketWinner && (
													<FontAwesomeIcon icon={faTrophy} style={{ color: styles.COLOR.BRAND_PRIMARY }} />
												)}
											</div>
										)} */}
										</a>
									</div>
									<div className={`Row-${i + 1}`}>{t.wins ?? '-'}</div>
									<div className={`Row-${i + 1}`}>{t.losses ?? '-'}</div>
								</Fragment>
							);
						})
					) : (
						<TBD />
					)}
				</div>
			</div>
		</>
	);
};

export default PlayoffsTable;
